import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import {
  StyledPackageOrVehicleWrapper,
  StyledButtonGroup,
  StyledDeliverQuestionModal,
} from './DeliverQuestion.style'
import { Icon, Packages, Vehicles, YoldaIcons } from '../../atoms'
import { makePackageData, makeVehicleData } from '../../../utils/helpers'
import { Trip } from '../../../utils/constants/Trip'
import { ShipmentType } from '../../../utils/constants/Shipment'

interface DeliverQuestionProps extends LibraryComponentType {
  onAction?: () => void
  item: Trip
}

const DeliverQuestion: FC<DeliverQuestionProps> = ({ onAction, item, onClose }) => {
  const { t } = useTranslation()

  const onClickDeliver = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledDeliverQuestionModal>
      <div>
        <Icon iconName={YoldaIcons.HubDoneGray} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.medium} mt={theme.spacing.medium}>
        {`${t('trip.deliverQuestionModal.title')}`}
      </Text>
      <StyledPackageOrVehicleWrapper>
        {item?.shipmentType === ShipmentType.FTL ? (
          <Vehicles
            data={makeVehicleData(
              item?.carrierVehicle?.vehicleType || '',
              item?.carrierVehicle?.vehicleBodyType || '',
              t
            )}
          />
        ) : (
          <Packages data={makePackageData(item?.packageSummary || {}, t)} />
        )}
      </StyledPackageOrVehicleWrapper>

      <Text as="p" fontSize="medium" mb={theme.spacing.large} mt={theme.spacing.large}>
        {`${t('trip.deliverQuestionModal.desc')}`}
      </Text>
      <StyledButtonGroup>
        <Button onClick={onClickDeliver} stretch>{`${t('trip.deliverQuestionModal.title')}`}</Button>
      </StyledButtonGroup>
    </StyledDeliverQuestionModal>
  )
}

DeliverQuestion.defaultProps = {
  onAction: () => null,
  item: undefined,
}

export default DeliverQuestion
